import { UnknownNode } from "../../errors";
import ledgerNodeApi from "./ledger";
import rpcNodeApi from "./rpc";
export const getNodeApi = (currency) => {
    var _a, _b;
    switch ((_b = (_a = currency.ethereumLikeInfo) === null || _a === void 0 ? void 0 : _a.node) === null || _b === void 0 ? void 0 : _b.type) {
        case "ledger":
            return ledgerNodeApi;
        case "external":
            return rpcNodeApi;
        default:
            throw new UnknownNode(`Unknown node for currency: ${currency.id}`);
    }
};
//# sourceMappingURL=index.js.map